var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"docs",attrs:{"src":_vm.$route.params.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }